const $ = jQuery.noConflict();

'use strict';
const Subscribe = {

	$domSubscribeEmail: null,
	$domSubscribeBtn: null,
	$domSubscribeForm: null,
	$domSubscribeSuccessMsg: null,
	$domSubscribeErrorMsg: null,
	$domSubscribeValidateMsg: null,

	init: ()=> {
		if ($('.js-subscribe-page').length === 0) return;
		Subscribe.initValues();
		Subscribe.bindEvents();
	},

	initValues: ()=>{
		Subscribe.$domSubscribeEmail = $('.js-subscribe-email');
		Subscribe.$domSubscribeForm = $('.js-subscribe-form');
		Subscribe.$domSubscribeBtn = Subscribe.$domSubscribeForm.find('.js-submit-btn');
		Subscribe.$domSubscribeSuccessMsg = $('.js-subscribe-success-msg');
		Subscribe.$domSubscribeErrorMsg = $('.js-subscribe-error-msg');
		Subscribe.$domSubscribeValidateMsg = $('.js-subscribe-validate-msg');
	},

	bindEvents: function() {
		Subscribe.$domSubscribeBtn.on('click', (event)=>{
			event.preventDefault();
			Subscribe.disableBtn(true);
			$('.js-alert-loader').addClass('active-loader');
			const validate = Subscribe.validate();
			if (validate.status) {
				Subscribe.showSuccessMsg(false);
				Subscribe.showErrorMsg(false);
				Subscribe.showValidateMsg(false);
				Subscribe.sendRequest();
				setTimeout(()=>{$('.js-alert-loader').removeClass('active-loader');}, 1000);
			} else {
				Subscribe.showSuccessMsg(false);
				Subscribe.showErrorMsg(false);
				Subscribe.showValidateMsg(true, validate.message);
				setTimeout(()=>{$('.js-alert-loader').removeClass('active-loader');}, 1000);
				Subscribe.disableBtn(false);
			}
		});
	},

	validate: ()=>{
		if (Subscribe.$domSubscribeEmail.val() === '') {
			return {
				status: false,
				message: 'Email address is required!'
			};
		}
		if (!Subscribe.isEmail(Subscribe.$domSubscribeEmail.val().trim())) {
			return {
				status: false,
				message: 'Email address is not a valid!'
			};
		}
		return {
			status: true,
			message: '',
		};
	},

	// check email address
	isEmail: function(email) {
		const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return regex.test(email);
	},


	sendRequest: ()=> {
		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: {
				action: 'alert-subscribe',
				email: Subscribe.$domSubscribeEmail.val(),
			},
			success: (response)=> {
				if (response.success) {
					Subscribe.$domSubscribeEmail.val('');
					Subscribe.showSuccessMsg(true);
				} else {
					Subscribe.showErrorMsg(true);
				}
			}, complete: ()=>{
				Subscribe.disableBtn(false);
			}
		});
	},

	disableBtn: (show)=>{
		$('.js-submit-btn').toggleClass('btn-disabled', show);
	},

	showSuccessMsg: (show)=>{
		Subscribe.$domSubscribeSuccessMsg.toggleClass('success-subscribe', show);
	},

	showErrorMsg: (show)=>{
		Subscribe.$domSubscribeErrorMsg.toggleClass('error-subscribe', show);
	},

	showValidateMsg: (show, message = '')=>{
		$('.js-subscribe-validate-text').text(message);
		Subscribe.$domSubscribeValidateMsg.toggleClass('validate-subscribe', show);
	},
};

export default Subscribe;
